// extracted by mini-css-extract-plugin
module.exports = {"heading":"Recommendations_heading__lk6L5","description":"Recommendations_description__2PleF","grid":"Recommendations_grid__PMTAA"};